import React, { useCallback } from 'react';
import { usePendingJobs } from 'hooks/usePendingJobs/usePendingJobs';
import { useTranslation } from 'react-i18next';
import Spinner from 'components/Spinner';
import JourneysList from 'components/JourneysList';
import { useHistory } from 'react-router-dom';
import { ROUTES } from 'utils/constants/routes';

const PendingJobs = ({ className }) => {
  const { pendingJobs, error, loading } = usePendingJobs();
  const { t } = useTranslation('Jobs');
  let history = useHistory();

  const handleClick = useCallback(
    id => history.push(`${ROUTES.PENDING_DETAIL.DEFAULT}/${id}`),
    [history]
  );

  const renderPendingJobs = useCallback(() => {
    if (loading) {
      return (
        <div className="pending-jobs__loading" data-testid="loading">
          <Spinner />
        </div>
      );
    }

    if (error) {
      return <div data-testid="error">{t('error')}</div>;
    }

    if (!pendingJobs || pendingJobs.length === 0) {
      return (
        <div className="pending-jobs__alert" data-testid="no-pending-jobs">
          {t('noPendingJobs')}
        </div>
      );
    }

    return (
      <JourneysList
        journeys={pendingJobs}
        parentClass="pending-jobs"
        handleClick={handleClick}
      />
    );
  }, [error, loading, pendingJobs, t, handleClick]);

  return (
    <div className={className} data-testid="root">
      <div className="pending-jobs">
        <div className="pending-jobs__container">{renderPendingJobs()}</div>
      </div>
    </div>
  );
};

export default PendingJobs;
